<template>
  <span class="view-icon" :id="field.key">
    <!-- Si es array, mostrar todos los iconos -->
    <span v-if="field.isArray && Array.isArray(displayValue)">
      <span
        v-for="(iconValue, index) in displayValue"
        :key="index"
        class="icon-item"
      >
        <i class="material-icons" style="fontSize: '24px'">{{ iconValue }}</i>
        <span v-if="index < displayValue.length - 1">, </span>
      </span>
    </span>
    <!-- Valor simple -->
    <span v-else-if="displayValue">
      <i class="material-icons" style="fontSize: '24px'">{{ displayValue }}</i>
    </span>
    <span v-else class="text-muted">{{ $t('No icon') }}</span>
  </span>
</template>

<script>
export default {
  name: "ViewFieldIcon",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array],
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      if (this.field.defaultValue !== undefined && this.field.defaultValue !== null) {
        return this.field.defaultValue;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.view-icon {
  font-weight: 500;
}

.icon-item {
  display: inline;
}
</style>

